/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Col, DatePicker, Form, Row, Typography } from "antd";
import jwtDecode from "jwt-decode";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Notification from "../../../components/shared/Notification";
import { formatDate } from "../../../helpers/formatDate";

const { Text } = Typography;
const ViewReportDatePicker = ({ url, request }) => {
  const location = useLocation().state;
  const token = localStorage.getItem("token");
  const loginAs = jwtDecode(token).loginAs;
  const [datesWithRecord, setdatesWithRecord] = useState([]);
  const [buttonDates, setbuttonDates] = useState(moment());

  const [forms] = Form.useForm();
  const navigate = useNavigate();

  const loadDatesOfReports = async () => {
    const token = localStorage.getItem("token");
    await request
      .getDatesOfReports(location.establishmentId, token)
      .then((result) => {
        let _dates = [];
        result.forEach((_result) => _dates.push(_result.date));
        setdatesWithRecord(_dates);
      });
  };

  const onSubmit = async (value) => {
    value.date = formatDate(value.date);
    value.establishmentId = location.establishmentId;
    let res = await request.getReportByDate(value, token);
    if (!res) {
      navigate(`../${url}/view/no-record`, {
        replace: true,
        state: { ...value },
      });
    } else {
      res.establishmentId = location.establishmentId;

      navigate(
        `../${url}/view/${
          url === "mice-reports" ? value.date : res?.transactionId
        }`,
        {
          replace: true,
          state: url === "mice-reports" ? res : { ...res },
        }
      );
    }
  };

  const onChangeHandler = (_, dateString) => {
    setbuttonDates(dateString);
  };

  useEffect(() => {
    if (loginAs === "Administrator") {
      let date = forms.getFieldValue("date");
      if (date) forms.submit();
    }
  }, [buttonDates]);

  useEffect(() => {
    if (loginAs === "Administrator") loadDatesOfReports();
  }, []);

  useEffect(() => {
    if (!location) {
      Notification(
        "Error",
        "Please select an establishment to view this page.",
        "error"
      );

      return navigate(`/v2/${loginAs}`);
    }
  }, [location]);

  return (
    <center>
      <div style={{ margin: "15px 0 15px 0", width: "95vw" }}>
        {loginAs === "Administrator" ? (
          <Form
            form={forms}
            initialValues={{
              date: location?.date ? moment(new Date(location.date)) : null,
            }}
            onFinish={onSubmit}
          >
            <Row align="middle" justify="center">
              <Text>Select Date of Report</Text>
            </Row>
            <Row gutter={5}>
              <Col span={7}>
                <Button
                  type="primary"
                  onClick={() => {
                    setbuttonDates(
                      moment(buttonDates).subtract(1, "d").format("YYYY-MM-DD")
                    );
                    forms.setFieldsValue({
                      date: moment(buttonDates, "YYYY-MM-DD").subtract(1, "d"),
                    });
                  }}
                  block
                >
                  {moment(buttonDates).subtract(1, "d").format("YYYY-MM-DD")}
                </Button>
              </Col>
              <Col span={10}>
                <Form.Item
                  style={{ margin: 0 }}
                  name={"date"}
                  rules={[
                    {
                      required: true,
                      message: "Please select a date!",
                    },
                  ]}
                >
                  <DatePicker
                    onChange={onChangeHandler}
                    style={{ width: "100%" }}
                    allowClear={false}
                    placement="bottomLeft"
                    dateRender={(current) => {
                      const style = {};
                      if (
                        datesWithRecord.includes(current.format("YYYY-MM-DD"))
                      ) {
                        style.backgroundColor = "red";
                        style.color = "#fff";
                        style.borderRadius = "5%";
                      }
                      return (
                        <div className="ant-picker-cell-inner" style={style}>
                          {current.date()}
                        </div>
                      );
                    }}
                  />
                </Form.Item>
              </Col>
              <Col span={7}>
                <Button
                  type="primary"
                  block
                  onClick={() => {
                    setbuttonDates(
                      moment(buttonDates).add(1, "d").format("YYYY-MM-DD")
                    );
                    forms.setFieldsValue({
                      date: moment(buttonDates, "YYYY-MM-DD").add(1, "d"),
                    });
                  }}
                >
                  {moment(buttonDates).add(1, "d").format("YYYY-MM-DD")}
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <Text>Report for the date: {formatDate(location.date)}</Text>
        )}
      </div>
    </center>
  );
};

export default ViewReportDatePicker;
